import { TextField } from '@hulu/react-style-components';
import React, { useState } from 'react';
import { PatternFormat } from 'react-number-format';

import { ElementWrapper, TextFieldContainerStyled } from '../../../pages/Login/styled';
import { BlueButton } from '../../BlueTheme';
import StepHeader from '../StepHeader/StepHeader';
import { TextFieldWrapper } from './styled';

type Props = {
  onSetPhone: (phoneNumber: string) => void;
  loading: boolean;
};

const SetPhoneStep = ({ onSetPhone, loading }: Props): JSX.Element => {
  const [touched, setTouched] = useState(false);
  const [phone, setPhone] = useState('');
  const handleSubmit = (): void => {
    onSetPhone(`+1${phone}`);
  };

  const errorMessage = phone.length < 10 && 'Please enter a valid phone number.';

  return (
    <>
      <StepHeader subTitle={<>First we need to set up multi-factor authentication.</>} />
      <TextFieldContainerStyled data-testid="fieldPhoneWrapper">
        <TextFieldWrapper>
          <PatternFormat
            data-testid="fieldPhone"
            errMsg={touched && errorMessage}
            label="Phone Number"
            placeholder="(000)000-0000"
            onFocus={(): void => {
              setTouched(true);
            }}
            customInput={TextField}
            format="(###)###-####"
            onValueChange={(patternValue): void => {
              setPhone(patternValue.value);
            }}
          />
        </TextFieldWrapper>
      </TextFieldContainerStyled>
      <ElementWrapper>
        <BlueButton
          name="Send Code"
          type="submit"
          onClick={handleSubmit}
          disabled={!!errorMessage || loading}
          isLoading={loading}
          data-testid="setPhoneSubmitButton"
        />
      </ElementWrapper>
    </>
  );
};

export default SetPhoneStep;
